module.exports = "<div id=\"masthead__logout\" class=\"masthead__wrapper\" (click)=\"clickedLogout()\">    \n    <i class=\"masthead__icon ico icon-log-out\"></i>\n    <span class=\"masthead__label\">{{ 'CELINE_LOGOUT' | translate }}</span>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/threshold/components/logout/logout.component.html
// module id = ./src/app/threshold/components/logout/logout.component.html
// module chunks = 0